import {useQueryClient} from '@tanstack/react-query';
import {ReactNode, useEffect, useState} from 'react';
import {Loading} from '../../../../design-system/atoms/Loading/Loading';
import {ViewerInfo} from '../../../../graphql/generated/types';
import {useViewerInfoQuery} from '../../../../wrapper/viewerWrapper';
import {useFetchTextViewerPreview} from '../../../content/[seriesId]/viewer/[productId]/hook/useFetchTextViewerPreview';

export function CmsTextViewerFetcherHeadless({
  previewKey,
  isProductId,
  children,
}: {
  previewKey: string;

  isProductId?: boolean;
  children: (viewerInfo: ViewerInfo) => ReactNode;
}) {
  const queryClient = useQueryClient();
  const [isCacheSet, setIsCacheSet] = useState(false);

  const {data, isLoading} = useFetchTextViewerPreview({
    previewKey,
    isProductId,
  });

  const viewerInfoData = data;

  // useFetchTextViewerPreview로 가져온 데이터를 자식 useViewerInfoQuery 호출 시 fetch 없이 사용하기 위해 캐시에 설정
  useEffect(() => {
    if (viewerInfoData) {
      const seriesId = Number(viewerInfoData.seriesItem.seriesId);
      const productId = Number(viewerInfoData.item.productId);

      const queryKey = useViewerInfoQuery.getKey({seriesId, productId});

      queryClient.setQueryData(queryKey, viewerInfoData);

      setIsCacheSet(true);
    }
  }, [viewerInfoData, queryClient]);

  if (!children) {
    return null;
  }
  return (
    <>
      {(isLoading || !viewerInfoData || !isCacheSet) && (
        <div className="flex-center-full">
          <Loading />
        </div>
      )}
      {!isLoading && viewerInfoData && isCacheSet && (
        <>{children(viewerInfoData)}</>
      )}
    </>
  );
}
